export default {
    "all-classes": "All classes",
    "class": "Class",
    "all-students": "All students",
    "for-all-students": "For all students",
    "group-messages-sent": "Group messages sent",
    "wait-a-little": "Wait a little",
    "no-messages": "No messages",
    "for-the-whole-school": "For the whole school",
    "to": "To",
    "students": "Students"
}